import { SubscriptionService } from '@/services/api/subscription'
import {
  SubmitChangePayment,
  SubmitParameter
} from '@spa/components/pages/mypage/subscription/contracted/detail/edit/payment/interaction/submit-change-payment'
import { Either } from 'fp-ts/lib/Either'

export class SubmitChangePaymentDefault implements SubmitChangePayment {
  constructor(
    private readonly subscriptionApiServiceViaLegacyProxy: SubscriptionService
  ) {
  }
  submit(id: string, param: SubmitParameter): Promise<Either<Error, null>> {
    return this.subscriptionApiServiceViaLegacyProxy.edit(
      id,
      {
        payment: JSON.stringify(param),
      }
    )
  }
}
